import { Menu, Drawer, Button } from "antd";
import {
  AppstoreOutlined,
  SettingOutlined,
  LoginOutlined,
  UserOutlined,
  UserSwitchOutlined,
  DollarOutlined,
  ScheduleOutlined,
  WindowsOutlined,
  MenuOutlined,
} from "@ant-design/icons";

import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { delUser } from "../../app/features/user/userSlice";
import { set_ch, set_la } from "../../app/features/lg/lgSlice";
import text from "../../text.json";
import { changLg, changLgValue } from "../../data/allfunction_2";
const { SubMenu } = Menu;

export default function MenuBar() {
  const user = useSelector((state) => state.user);
  const { value } = useSelector((state) => state.lg);
  const location = useLocation();
  const dispatch = useDispatch();

  const [current, setCurrent] = useState(location.pathname);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [show, set_show] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    try {
      set_show(JSON.parse(user.agent_conf).non_motor);
    } catch (error) {
      set_show(false);
    }
  }, [user]);

  const menuContent = (
    <Menu
      selectedKeys={[current]}
      mode={isMobile ? "vertical" : "horizontal"} // Mobile: vertical, Desktop: horizontal
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row", // Mobile: column, Desktop: row
        flexWrap: "wrap",
        flex: 1,
      }}
    >



      <Menu.Item key="/saleOnline" icon={<WindowsOutlined />}>
        <Link to="/saleOnline">{changLg(1)}</Link>
      </Menu.Item>
      <Menu.Item key="/saleOnline/sellshot" icon={<AppstoreOutlined />}>
        <Link to="/saleOnline/sellshot">{changLg(2)}</Link>
      </Menu.Item>
      <Menu.Item key="/saleOnline/sellpac" icon={<AppstoreOutlined />}>
        <Link to="/saleOnline/sellpac"> {changLg(3)} </Link>
      </Menu.Item>
      <Menu.Item key="/saleOnline/sellnonmotor" icon={<AppstoreOutlined />}>
        <Link to="/saleOnline/sellnonmotor">{changLg(4)}</Link>
      </Menu.Item>

      <SubMenu key="/saleOnline/marketing" icon={<SettingOutlined />} title={changLg(5)} >
        <Menu.ItemGroup title="ການຕະຫລາດ">
          <Menu.Item key="/saleOnline/AccountFinance">
            <Link to="/saleOnline/AccountFinance">{changLg(93)} </Link>
          </Menu.Item>
          {show && (
            <Menu.Item key="/saleOnline/AccNonMotor">
              <Link to="/saleOnline/AccNonMotor">ການຂາຍ ປະກັນໄພ PA HPA ITI</Link>
            </Menu.Item>
          )}
        </Menu.ItemGroup>
      </SubMenu>

      {(user.level === "manager" || user.level === "acc") && (
        <SubMenu key="/saleOnline/accoun" icon={<DollarOutlined />} title="ບັນຊີ - ການເງິນ">
          <Menu.ItemGroup title="ບັນຊີ">
            <Menu.Item key="/saleOnline/confirmPaid">
              <Link to="/saleOnline/confirmPaid">ຢັ້ງຢືນການຮັບເງິນ</Link>
            </Menu.Item>
            <Menu.Item key="/saleOnline/cancelpolicy">
              <Link to="/saleOnline/cancelpolicy">ຍົກເລີກ ສັນຍາ ປະກັນໄພລົດ</Link>
            </Menu.Item>
          </Menu.ItemGroup>
        </SubMenu>
      )}

      {user.level === "manager" && (
        <Menu.Item key="/saleOnline/confirmPaidLate" icon={<ScheduleOutlined />}>
          <Link to="/saleOnline/confirmPaidLate">ອະນຸຍາດໃຫ້ຈ່າຍຊ້າ</Link>
        </Menu.Item>
      )}

      {user.level === "manager" && (
        <Menu.Item key="/users" icon={<UserOutlined />}>
          <Link to="/saleOnline/user">ຈັດການຜູ້ໃຊ້ງານ</Link>
        </Menu.Item>
      )}


      <SubMenu key="/user" icon={<UserSwitchOutlined />} title={user.name}>
        <Menu.Item key="/login" icon={<LoginOutlined />}>
          <Link
            onClick={() => {
              dispatch(delUser());
            }}
            to="/saleOnline/login"
          >
            {changLg(82)}
          </Link>
        </Menu.Item>
        <Menu.Item >
          <Button
            onClick={() => {
              if (value == 2) {
                dispatch(set_la());
                console.log(value)
              } else if (value == 1) {
                dispatch(set_ch());
                console.log(value)
              }
              return
            }}

          >
            {value != 1 ? "LA" : "CH"}
          </Button>
        </Menu.Item>
      </SubMenu>
      <Menu.Item >
      </Menu.Item>

    </Menu>
  );


  const menuTitles = {
    "/saleOnline": `${changLgValue(value, 1)} `,
    "/saleOnline/sellshot": `${changLgValue(value, 2)}`,
    "/saleOnline/sellpac": `${changLgValue(value, 3)}`,
    "/saleOnline/sellnonmotor": `${changLgValue(value, 4)} `,
    "/saleOnline/AccountFinance": `${changLgValue(value, 93)} `,
    "/saleOnline/AccNonMotor": "ການຂາຍ ປະກັນໄພ PA HPA ITI",
    "/saleOnline/confirmPaid": "ຢັ້ງຢືນການຮັບເງິນ",
    "/saleOnline/cancelpolicy": "ຍົກເລີກ ສັນຍາ ປະກັນໄພລົດ",
    "/saleOnline/confirmPaidLate": "ອະນຸຍາດໃຫ້ຈ່າຍຊ້າ",
    "/saleOnline/user": "ຈັດການຜູ້ໃຊ້ງານ",
    "/saleOnline/login": "ອອກຈາກລະບົບ"
  };

  const pageTitle = menuTitles[location.pathname] || "ໜ້າຫຼັກ";
  return (

    <div>
      {isMobile ? (
        <>
          <div
            style={{
              paddingTop: 1,
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "0.5px solid darkgray",
            }}
          >
            <h5 style={{ paddingTop: 12, paddingLeft: 8 }}> ZJI {pageTitle}</h5>

            <Button
              type="primary"
              icon={<MenuOutlined />}
              onClick={() => setDrawerVisible(true)}
              style={{ marginTop: 8, marginRight: 8 }}
            />
          </div>

          <Drawer
            title="ເມນູ"
            placement={"bottom"}
            closable
            onClose={() => setDrawerVisible(false)}
            visible={drawerVisible}
          >
            {menuContent}
          </Drawer>
        </>
      ) : (
        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
          {menuContent}
        </div>
      )}
    </div>



  );
}
